<template>
  <div class="container">
    <div class="back"></div>
    <div class="login-container">
      <div class="login-form">
        <el-form
          :model="dataForm"
          :rules="dataRule"
          ref="dataForm"
          @keyup.enter.native="loginSubmit()"
        >
          <el-form-item prop="username">
            <el-input
              v-model="dataForm.username"
              prefix-icon="el-icon-user-solid"
              placeholder="请输入用户名"
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="dataForm.password"
              type="password"
              prefix-icon="el-icon-unlock"
              placeholder="请输入密码"
            />
          </el-form-item>
          <el-form-item size="large">
            <el-button
              type="primary"
              style="width: 100%;"
              @click="loginSubmit"
              :loading="loginBtn.loading"
              >{{ loginBtn.text }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/api/auth";

export default {
  name: "login",
  data() {
    return {
      dataForm: {
        username: "",
        password: ""
      },
      loginBtn: {
        loading: false,
        text: "登录"
      },
      dataRule: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      }
    };
  },
  methods: {
    loginSubmit() {
      this.changeLoginBtn(false);
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          auth
            .login(this.dataForm)
            .then(result => {
              this.$store.commit(
                this.$u.vuexConst.USER_STATE_PREFIX +
                  this.$u.vuexConst.UPDATE_TOKEN,
                result.data
              );
              this.changeLoginBtn(true);
              this.$router.replace({ name: this.$u.routerConst.HOME });
            })
            .catch(() => {
              this.changeLoginBtn(true);
            });
        }
      });
    },
    changeLoginBtn(isReset) {
      if (isReset) {
        this.loginBtn.loading = false;
        this.loginBtn.text = "登录";
      } else {
        this.loginBtn.loading = true;
        this.loginBtn.text = "登录中...";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.back {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 1000px;
  z-index: -10;
  zoom: 1;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background: #fff url(~@/assets/img/login-back.jpg) no-repeat center 0;
}
.container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: center;
  font-size: 0;
  white-space: nowrap;
  overflow: auto;
}

.container:after {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.login-container {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  font-size: 14px;
  white-space: normal;
  min-height: 200px;
  min-width: 300px;
  width: 350px;
  height: 250px;
  border-radius: 4px;
  -webkit-box-shadow: 4px 2px 17px 4px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 4px 2px 17px 4px rgba(0, 0, 0, 0.12);
  box-shadow: 4px 2px 17px 4px rgba(0, 0, 0, 0.12);
  background-image: linear-gradient(90deg, #5f676373 0, #67c23a38) !important;
}

.login-form {
  margin: 3rem;
}
</style>
